export default "__VITE_ASSET__Clu3XCEH__"